import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonFunctionsService {

  constructor() { }

  getNextDayOfTheWeek(dayName, excludeToday = true, refDate = new Date()) {
    const dayOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
      .indexOf(dayName.slice(0, 3).toLowerCase());
    if (dayOfWeek < 0) { return; }
    refDate.setHours(0, 0, 0, 0);
    // @ts-ignore
    refDate.setDate(refDate.getDate() + !!excludeToday +
      // @ts-ignore
      (dayOfWeek + 7 - refDate.getDay() - !!excludeToday) % 7);
    return refDate;
  }

  escapeSpecialsURL(val) {
    val = val.replaceAll(/%/gi, '%25');

    const map = {
      '%26' : '&',
      '%23' : '#'
    };

    // tslint:disable-next-line:forin
    for (const pattern in map) {
      val = val.replace(new RegExp(map[pattern], 'g'), pattern);
    }

    return val;
  }

  remove_emojis(str) {
    return str.replace(/\p{Emoji}/gu, '');
  }

  remove_accents(str) {
    const map = {
        'a' : 'á|à|ã|â|ä|å',
        'A' : 'À|Á|Ã|Â|Ä|Å',
        'e' : 'é|è|ê',
        'E' : 'É|È|Ê',
        'i' : 'í|ì|î|ï|ī',
        'I' : 'Í|Ì|Î|Ï|Ī',
        'o' : 'ó|ó|ò|ô|õ|ø|ö',
        'O' : 'Ó|Ó|Ò|Ô|Õ|Ø|Ö',
        'u' : 'ú|ù|û|ü|ū',
        'U' : 'Ú|Ù|Û|Ü|Ū',
        'c' : 'ç',
        'C' : 'Ç',
        'n' : 'ñ',
        'N' : 'Ñ',
        'y' : 'ý|ÿ',
        'Y' : 'Ý',
        '"' : '“|”',
        "'" : '’|´|`'
    };

    for (let pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern);
    }

    return str;
  }

  /**
   * Force une valeur (lien Instagram, @pseudo, #pseudo, ou juste le pseudo) au format "@pseudo" :
   *  - lien instagram.com/xxx -> @xxx (rejeté si xxx est un chemin non-profil : p, reel, stories...)
   *  - lien vers un autre réseau (Facebook, Twitter/X, TikTok...) ou une autre URL -> null (hors sujet)
   *  - #pseudo -> @pseudo
   *  - pseudo seul -> @pseudo
   * Retourne null si rien d'exploitable (aucune donnée conservée plutôt qu'une valeur douteuse).
   * Utilisé pour normaliser la saisie manuelle dans la colonne Instagram (voir afterChange).
   */
  formatInstagramHandle(raw: string): string | null {
    if (!raw) { return null; }
    const value = String(raw).trim();
    if (!value) { return null; }

    const RESERVED_PATHS = ['p', 'reel', 'reels', 'stories', 'explore', 'accounts', 'directory', 'about', 'legal', 'developer', 'tv'];
    const OTHER_SOCIAL_DOMAINS = /(facebook|fb|twitter|x|tiktok|youtube|threads)\.com/i;
    const HANDLE_RE = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._]{1,30}(?<!\.)$/;

    const instagramUrlMatch = value.match(/instagram\.com\/([^/?#\s]+)/i);
    let candidate: string;

    if (instagramUrlMatch) {
      candidate = instagramUrlMatch[1];
      if (RESERVED_PATHS.includes(candidate.toLowerCase())) { return null; }
    } else if (/:\/\//.test(value) || OTHER_SOCIAL_DOMAINS.test(value)) {
      // Lien vers autre chose qu'Instagram : hors sujet, on ne garde rien plutôt que de mal l'interpréter.
      return null;
    } else if (value.startsWith('@') || value.startsWith('#')) {
      candidate = value.slice(1);
    } else {
      candidate = value;
    }

    candidate = candidate.trim();
    return HANDLE_RE.test(candidate) ? ('@' + candidate) : null;
  }

}
